// localStorage helpers. Pure JS for now; Lane B replaces these with
// Bitable-backed API client calls.

import { VAVA_SEED } from './seed.js';

export const STORAGE = {
  session: 'vava_session',
  tasks: 'vava_tasks',
  viewMode: 'vava_view_mode'
};

export function loadTasks() {
  let tasks;
  try {
    const raw = localStorage.getItem(STORAGE.tasks);
    if (raw) tasks = JSON.parse(raw);
  } catch (_) {}
  if (!tasks) tasks = JSON.parse(JSON.stringify(VAVA_SEED.TASKS));
  // Migrate legacy single-assignee shape → multi-owner RACI shape.
  // Idempotent: tasks that already have owners[] are untouched.
  return tasks.map(t => {
    if (t.owners && t.owners.length > 0) return t;
    if (t.assigneeId) return { ...t, owners: [{ staffId: t.assigneeId, role: 'R' }] };
    return { ...t, owners: [] };
  });
}

export function saveTasks(tasks) {
  try { localStorage.setItem(STORAGE.tasks, JSON.stringify(tasks)); }
  catch (e) {
    if (e && e.name === 'QuotaExceededError') window.alert('保存失败:浏览器存储已满,请清理后重试。');
    else console.error('saveTasks failed', e);
  }
}

export function loadSession() {
  try { return JSON.parse(localStorage.getItem(STORAGE.session) || 'null'); }
  catch (_) { return null; }
}

export function saveSession(session) {
  if (session) localStorage.setItem(STORAGE.session, JSON.stringify(session));
  else localStorage.removeItem(STORAGE.session);
}

export function loadViewMode() {
  return localStorage.getItem(STORAGE.viewMode) || 'kanban';
}

export function saveViewMode(m) {
  localStorage.setItem(STORAGE.viewMode, m);
}
